import { useTheme } from '@capturi/ui-theme'

export type WidgetBackgroundColorName =
  | 'default'
  | 'blue'
  | 'sand'
  | 'green'
  | 'yellow'
  | 'red'
  | 'transparent'

export const useAllWidgetColors = (): Record<
  WidgetBackgroundColorName,
  string
> => {
  const { colors } = useTheme()

  return {
    default: '#FAFAFA',
    blue: colors.widgetBackground.blue,
    sand: colors.widgetBackground.sand,
    green: colors.widgetBackground.green,
    yellow: colors.widgetBackground.yellow,
    red: colors.widgetBackground.red,
    transparent: 'transparent',
  }
}

export function useColorValue(
  colorName: string | null | undefined,
  fallback: WidgetBackgroundColorName = 'default',
): string {
  const widgetColors = useAllWidgetColors()

  return (
    widgetColors[colorName as WidgetBackgroundColorName] ||
    widgetColors[fallback]
  )
}
